import { render, staticRenderFns } from "./openFz.vue?vue&type=template&id=1d5f220e"
import script from "./openFz.vue?vue&type=script&lang=js"
export * from "./openFz.vue?vue&type=script&lang=js"
import style0 from "./openFz.vue?vue&type=style&index=0&id=1d5f220e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports